/* eslint-disable react/prop-types */
import isNil from 'lodash/isNil';
import values from 'lodash/values';
import PropTypes from 'prop-types';
import React from 'react';

import { interactiveIcons } from '../../../constants/Icon';
import QATags from '../../../constants/QATags';
import { handlerNoPropagate } from '../../../lib/EventUtils';
import { createBEM } from '../../../lib/utils/css';
import Icon from '../../Icon/Icon';
import Tooltip from '../Tooltip/Tooltip';

import './IconInteractive.scss';

class IconInteractive extends React.Component {
  /**
   * @property {String,Object} glyph - Can either be a path or an object with default/hover paths
   * @property {string} glyphLookup - name to be looked up in dictionary in constants/Icon.js interactiveIcons
   * @property {boolean} isHovered - Renders glyphHover if true, otherwise, renders glyph
   * If isHovered prop is not passed in, IconInteractive will manage its own hover state.
   */
  static propTypes = {
    qaTag: PropTypes.string,
    qaIconInteractive: PropTypes.oneOf(values(QATags)),
    glyph: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    glyphLookup: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func,
    isHovered: PropTypes.bool,
    tooltipText: PropTypes.string,
    ariaExpanded: PropTypes.bool,
    ariaControls: PropTypes.string,
    buttonRef: PropTypes.func,
    size: PropTypes.oneOf(['small', 'large', 'xlarge']),
    isDark: PropTypes.bool,
    isMenuItem: PropTypes.bool,
    isInactive: PropTypes.bool,
  };

  state = {
    manageHoverState: isNil(this.props.isHovered),
    isHovered: false,
  };

  mouseEnter = () => {
    if (this.state.manageHoverState) {
      this.setState({
        isHovered: true,
      });
    }
  };

  mouseLeave = () => {
    if (this.state.manageHoverState) {
      this.setState({
        isHovered: false,
      });
    }
  };

  render() {
    const {
      qaIconInteractive,
      qaTag,
      glyphLookup,
      style,
      onClick,
      isHovered,
      ariaExpanded,
      ariaControls,
      size,
      tooltipText,
    } = this.props;
    let glyph = this.props.glyph;

    if (glyphLookup) {
      glyph = interactiveIcons[glyphLookup];
    }

    const glyphHover = glyph.hover ? glyph.hover : null;
    glyph = glyph.default ? glyph.default : glyph;

    const iconInteractiveParentClass = createBEM('IconInteractive', {
      [size]: !!size,
      menuItem: this.props.isMenuItem,
      dark: this.props.isDark,
      inactive: this.props.isInactive,
      button: !!onClick,
    });
    const iconInteractiveIconClass = 'IconInteractive__icon';
    const onIconClick = onClick ? handlerNoPropagate(onClick) : null;
    if (onIconClick) {
      return (
        <button
          title={tooltipText}
          className={iconInteractiveParentClass}
          aria-expanded={ariaExpanded}
          aria-controls={ariaControls}
          data-qa={qaIconInteractive}
          onClick={onIconClick}
          onMouseEnter={this.mouseEnter}
          onMouseLeave={this.mouseLeave}
          ref={this.props.buttonRef}
          type='button'
        >
          {(isHovered || this.state.isHovered) && !isNil(glyphHover) ? (
            <Icon
              qaTag={qaTag}
              style={style}
              className={iconInteractiveIconClass}
              glyph={glyphHover}
            />
          ) : (
            <Icon qaTag={qaTag} style={style} className={iconInteractiveIconClass} glyph={glyph} />
          )}
          <span aria-hidden='true'>{tooltipText && <Tooltip tipText={tooltipText} />}</span>
        </button>
      );
    }
    return (
      <span
        title={tooltipText}
        className={iconInteractiveParentClass}
        data-qa={qaIconInteractive}
        onMouseEnter={this.mouseEnter}
        onMouseLeave={this.mouseLeave}
      >
        {(isHovered || this.state.isHovered) && !isNil(glyphHover) ? (
          <Icon
            qaTag={qaTag}
            style={style}
            className={iconInteractiveIconClass}
            glyph={glyphHover}
          />
        ) : (
          <Icon qaTag={qaTag} style={style} className={iconInteractiveIconClass} glyph={glyph} />
        )}
        <span aria-hidden='true'>{tooltipText && <Tooltip tipText={tooltipText} />}</span>
      </span>
    );
  }
}

export default IconInteractive;
